import { jsxs as f, jsx as t } from "../../_virtual/jsx-runtime.mjs";
import * as o from "react";
import { w as y } from "../../packages/utils/dist/useIntersectionObserver-1ee6520e.mjs";
import v from "../../depend/classnames/index.mjs";
import { video as M } from "./css/Media.css.mjs";
import { useOmitProps as N } from "../../hook/useOmitProps.mjs";
const C = ["onWrapMouseEnter", "onWrapMouseLeave", "muted", "playsInline", "src", "icon", "className", "style", "commonClassName", "commonStyle"], s = o.forwardRef((e, l) => {
  const c = N(e, C), u = o.useMemo(() => v(
    M,
    e.commonClassName,
    e.className
  ), [e.className, e.commonClassName]), i = o.useMemo(
    () => ({
      ...e.commonStyle,
      ...e.style
    }),
    [e.commonStyle, e.style]
  ), n = o.useRef(null);
  o.useImperativeHandle(l, () => n.current, []);
  const r = o.useCallback((a) => {
    var m;
    (m = e.onWrapMouseEnter) == null || m.call(e, a);
  }, [e]), d = o.useCallback((a) => {
    var m;
    (m = e.onWrapMouseLeave) == null || m.call(e, a);
  }, [e]);
  return /* @__PURE__ */ f(
    "div",
    {
      className: u,
      style: i,
      onMouseEnter: r,
      onMouseLeave: d,
      children: [
        /* @__PURE__ */ t(
          "video",
          {
            ref: n,
            muted: !0,
            playsInline: !0,
            preload: "auto",
            ...c,
            children: e.src ? /* @__PURE__ */ t(
              "source",
              {
                src: e.src,
                type: "video/mp4"
              }
            ) : null
          }
        ),
        e.children,
        e.icon
      ]
    }
  );
});
s.displayName = "CommonVideo";
const I = y(s, {});
export {
  I as default
};
//# sourceMappingURL=CommonVideo.mjs.map
